import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import { type Notification } from "@/Modules/App/Models/Domain/Notification";

import { deletePromoCode } from "@/Services/TherapyApi/Users";

import useUserStore from "@/Modules/User/Store";

async function deletePromoCodeAH(userUuid: string): Promise<Notification | null> {
  const userStore = useUserStore();

  try {
    userStore.notification = null;
    userStore.isLoading = true;

    await deletePromoCode(userUuid);

    userStore.notification = {
      type: NotificationType.SUCCESS,
      code: null,
      message: "settings.subscription.patient.promo_code.errors.code_deleted",
    };
  } catch (error: unknown) {
    userStore.notification = {
      type: NotificationType.ERROR,
      message: "settings.subscription.patient.promo_code.errors.code_used",
      code: null,
    };
  } finally {
    userStore.isLoading = false;
  }

  return userStore.notification;
}

export default deletePromoCodeAH;
